'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _reactRouter = require('react-router');

var _App = require('./pages/App/App');

var _App2 = _interopRequireDefault(_App);

var _EnsureLoggedInContainer = require('./components/EnsureLoggedIn/EnsureLoggedInContainer');

var _EnsureLoggedInContainer2 = _interopRequireDefault(_EnsureLoggedInContainer);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (typeof require.ensure !== 'function') require.ensure = function (d, c) {
    c(require);
};

var getAboutUsPage = function getAboutUsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/AboutUs/AboutUsPageContainer'));
    }, 'AboutUsPage');
};

var getAccountSettingsPage = function getAccountSettingsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/AccountSettings/AccountSettingsPageContainer'));
    }, 'AccountSettingsPage');
};

var getAddCreditCardPage = function getAddCreditCardPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/AddCreditCard/AddCreditCardPageContainer'));
    }, 'AddCreditCardPage');
};

var getAuctionResultsPage = function getAuctionResultsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/AuctionResults/AuctionResultsPageContainer'));
    }, 'AuctionResultsPage');
};

var getBiddingConsolePage = function getBiddingConsolePage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/BiddingConsole/BiddingConsolePageContainer'));
    }, 'BiddingConsolePage');
};

var getCatalogPage = function getCatalogPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Catalog/CatalogPageContainer'));
    }, 'CatalogPage');
};

var getCategoryPage = function getCategoryPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Search/CategoryLandingPageContainer'));
    }, 'CategoryLandingPage');
};

var getCheckoutPage = function getCheckoutPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Checkout/CheckoutPageContainer'));
    }, 'CheckoutPage');
};

var getConsignmentsPage = function getConsignmentsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Consignments/ConsignmentsPageContainer'));
    }, 'ConsignmentsPage');
};

var getCookiePolicy = function getCookiePolicy(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Cookie/CookiePolicyPageContainer'));
    }, 'CookiePolicyPage');
};

var getCheckoutConfirmationPage = function getCheckoutConfirmationPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/CheckoutConfirmation/CheckoutConfirmationPageContainer'));
    }, 'CheckoutConfirmationPage');
};

var getFeaturesPage = function getFeaturesPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Features/FeaturesPageContainer'));
    }, 'FeaturesPage');
};

var getFollowedSellersPage = function getFollowedSellersPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/FollowedSellers/FollowedSellersPageContainer'));
    }, 'FollowedSellersPage');
};

var getHomePage = function getHomePage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Home/HomePageContainer'));
    }, 'HomePage');
};

var getHowItWorksPage = function getHowItWorksPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/HowItWorks/HowItWorksPageContainer'));
    }, 'HowItWorksPage');
};

var getIntellectualPropertyPage = function getIntellectualPropertyPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/IntellectualProperty/IntellectualPropertyPageContainer'));
    }, 'IntellectualPropertyPage');
};

var getItemPage = function getItemPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Item/ItemPageContainer'));
    }, 'ItemPage');
};

var getMessagesPage = function getMessagesPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Messages/MessagesPageContainer'));
    }, 'MessagesPage');
};

var getMobilePage = function getMobilePage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Mobile/MobilePageContainer'));
    }, 'MobilePage');
};

var getMyAuctionsPage = function getMyAuctionsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/MyAuctions/MyAuctionsPageContainer'));
    }, 'MyAuctionsPage');
};

var getMyBidsPage = function getMyBidsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/MyBids/MyBidsPageContainer'));
    }, 'MyBidsPage');
};

// All three saved search page chunks need to have the same name, or the page will not load
var getMySavedSearchPage = function getMySavedSearchPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/MySavedSearch/MySavedSearchPageContainer'));
    }, 'MySavedSearchPage');
};

var getMySavedSearchPageManage = function getMySavedSearchPageManage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/MySavedSearch/MySavedSearchPageManageTabContainer'));
    }, 'MySavedSearchPage');
};

var getMySavedSearchPageRecent = function getMySavedSearchPageRecent(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/MySavedSearch/MySavedSearchPageRecentTabContainer'));
    }, 'MySavedSearchPage');
};

var getNearMePage = function getNearMePage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/NearMe/NearMePageContainer'));
    }, 'NearMePage');
};

var getWonItemsPage = function getWonItemsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/WonItems/WonItemsPageContainer'));
    }, 'WonItemsPage');
};

var getNotFoundPage = function getNotFoundPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/NotFound/NotFound'));
    }, 'NotFoundPage');
};

var getIconTestPage = function getIconTestPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/IconTest/IconTestPage'));
    }, 'IconTestPage');
};

var getPasswordResetPage = function getPasswordResetPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/PasswordReset/PasswordResetPageContainer'));
    }, 'PasswordResetPage');
};

var getPrivacyPage = function getPrivacyPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Privacy/PrivacyPageContainer'));
    }, 'PrivacyPage');
};

var getPRServicesPage = function getPRServicesPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/PRServices/PRServicesPageContainer'));
    }, 'PRServicesPage');
};

var getSavedItemsPage = function getSavedItemsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/SavedItems/SavedItemsPageContainer'));
    }, 'SavedItemsPage');
};

var getCatalogSearchPage = function getCatalogSearchPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/CatalogSearch/CatalogSearchPageContainer'));
    }, 'CatalogSearchPage');
};

var getSearchPage = function getSearchPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Search/SearchPageContainer'));
    }, 'SearchPage');
};

var getDirectoryPage = function getDirectoryPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/SellerDirectory/SellerDirectoryPageContainer'));
    }, 'SellerDirectoryPage');
};

var getSellerPage = function getSellerPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Seller/SellerPageContainer'));
    }, 'SellerPage');
};

var getStorefrontPage = function getStorefrontPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Storefront/StorefrontPageContainer'));
    }, 'StorefrontPage');
};

var getSellerTestimonialsPage = function getSellerTestimonialsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/SellerTestimonials/SellerTestimonialsPageContainer'));
    }, 'SellerTestimonialsPage');
};

var getTerminologyPage = function getTerminologyPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/Terminology/TerminologyPageContainer'));
    }, 'TerminologyPage');
};

var getTermsAndConditionsPage = function getTermsAndConditionsPage(a, cb) {
    return require.ensure([], function (require) {
        cb(null, require('./pages/TermsAndConditions/TermsAndConditionsPageContainer'));
    }, 'TermsAndConditionsPage');
};

exports.default = function (isWhiteLabel) {
    var homeRoute = isWhiteLabel ? (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getSellerPage
    }) : (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getHomePage
    });

    return (0, _jsx3.default)(_reactRouter.Route, {
        component: _App2.default,
        path: '/'
    }, void 0, homeRoute, (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAboutUsPage,
        path: 'about'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAuctionResultsPage,
        path: 'auction-results'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getDirectoryPage,
        path: 'auctioneer/directory'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSellerPage,
        path: 'auctioneer/:sellerId/:sellerName'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getStorefrontPage,
        path: 'seller/:sellerId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getBiddingConsolePage,
        path: 'console/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c/:categoryName/:categoryId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c/:categoryName/:categoryName2/:categoryId/:categoryId2'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'price-guide/:categoryName/:categoryId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAuctionResultsPage,
        path: 'price-guide'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCatalogSearchPage,
        path: 'catalog/search'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCatalogPage,
        path: 'catalog/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getConsignmentsPage,
        path: 'consignments'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getConsignmentsPage,
        path: 'consignments/:sellerId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCookiePolicy,
        path: 'cookie-policy'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getFeaturesPage,
        path: 'features'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMobilePage,
        path: 'mobile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getNearMePage,
        path: 'find-auctions-near-me'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getHowItWorksPage,
        path: 'how-it-works'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getItemPage,
        path: 'item/:itemId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPasswordResetPage,
        path: 'password_reset/:bidderId/:hash'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPasswordResetPage,
        path: 'password_reset'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPRServicesPage,
        path: 'prservices'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPrivacyPage,
        path: 'privacy'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSearchPage,
        path: 'search'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSellerTestimonialsPage,
        path: 'seller-testimonials'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getTermsAndConditionsPage,
        path: 'termsandconditions'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getTerminologyPage,
        path: 'terminology'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getIntellectualPropertyPage,
        path: 'intellectualproperty'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        component: _EnsureLoggedInContainer2.default
    }, void 0, (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCheckoutConfirmationPage,
        path: 'confirmation/:sellerId/:itemId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAccountSettingsPage,
        path: 'dashboard/profile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAddCreditCardPage,
        path: 'dashboard/cardonfile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getFollowedSellersPage,
        path: 'dashboard/followed-auctioneers'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMessagesPage,
        path: 'dashboard/messages'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMyBidsPage,
        path: 'dashboard/my-bids'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMyAuctionsPage,
        path: 'dashboard/my-auctions'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMySavedSearchPage,
        path: 'dashboard/search-and-alerts'
    }, void 0, (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getMySavedSearchPageRecent
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMySavedSearchPageManage,
        path: 'manage'
    })), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSavedItemsPage,
        path: 'dashboard/saved-items'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCheckoutPage,
        path: 'checkout/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getWonItemsPage,
        path: 'dashboard/won-items'
    })), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getIconTestPage,
        path: 'icon-test'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getNotFoundPage,
        path: '*',
        status: 404
    }));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = eqvY
// module chunks = 60